const defaultRemoteConfig = {};

export default defaultRemoteConfig;
